var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      class: [
        _vm.$style.doughnut_chart_wrapper,
        _vm.config.large ? _vm.$style.doughnut_chart_wrapper_large : null,
        _vm.$style[_vm.labelPosition],
        "export_html_pie_chart_report_wrapper",
      ],
      style: { position: "relative" },
    },
    [
      _c("div", {
        ref: "chart",
        class: [_vm.$style.chart_body, "js_export_report_dymanic_chart"],
      }),
      _vm._v(" "),
      _vm.showStubDescription
        ? _c(
            "div",
            {
              ref: "stubDesc",
              class: _vm.$style.stub_desc,
              style: _vm.stubDescPosition,
            },
            [_c("span", [_vm._v(_vm._s(_vm.stubDescription))])]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.config.total
        ? _c(
            "div",
            {
              class: [
                _vm.$style.total_label,
                "export_html_pie_chart_total_label",
              ],
              style: _vm.totalLabelStyles,
            },
            [
              _vm._v("\n    " + _vm._s(_vm.config.total.label + ":") + " "),
              _c("span", [_vm._v(_vm._s("" + _vm.aggrQuantity))]),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        {
          class: [
            _vm.$style.legend,
            "export_html_pie_chart_report_legend",
            _vm.$style["legend_" + _vm.config.labelStyle],
          ],
        },
        _vm._l(_vm.items, function (item) {
          return _c("tooltip", {
            key: item.id,
            class: _vm.isGrayedOut(item.name) && "disabled",
            attrs: {
              content: item.name,
              position: "top",
              delay: 100,
              hide: !_vm.isOverflowed[item.name] || _vm.isGrayedOut(item.name),
            },
            scopedSlots: _vm._u(
              [
                {
                  key: "body",
                  fn: function () {
                    return [
                      _c(
                        "div",
                        {
                          class: [
                            _vm.$style.legend__item,
                            "export_html_pie_chart_report_legend_item",
                            _vm.isGrayedOut(item.name) && _vm.$style.grayed_out,
                          ],
                          on: {
                            mouseover: function ($event) {
                              return _vm.highlightSeries(item.name)
                            },
                            mouseleave: function ($event) {
                              return _vm.downplay(item.name)
                            },
                            click: function ($event) {
                              return _vm.toggleSelect(item.name)
                            },
                          },
                        },
                        [
                          _c("div", {
                            class: [
                              _vm.$style.legend_color_box,
                              "export_html_pie_chart_report_legend_box",
                            ],
                            style: {
                              backgroundColor: item.color,
                              width: _vm.config.legendStyles.boxWidth,
                              height: _vm.config.legendStyles.boxHeight,
                            },
                          }),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              ref: "legendName",
                              refInFor: true,
                              class: [
                                _vm.$style.legend_name,
                                "export_html_pie_chart_report_legend_name",
                              ],
                              style: {
                                fontSize: _vm.config.legendStyles.fontSize,
                              },
                            },
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(item.name) +
                                  "\n          "
                              ),
                            ]
                          ),
                        ]
                      ),
                    ]
                  },
                  proxy: true,
                },
              ],
              null,
              true
            ),
          })
        }),
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }